import { createFileRoute } from '@tanstack/react-router';
import { toolHead } from '../../../lib/toolHead';
import { TiktokAudienceAnalyzerPage } from '../../../pages/tools/creator-tools/TiktokAudienceAnalyzerPage';

export const Route = createFileRoute('/_site/tools/tiktok-audience-analyzer')({
  head: () => toolHead('tiktok-audience-analyzer'),
  component: TiktokAudienceAnalyzerPage,
});
